// extracted by css-extract-rspack-plugin
export default {"row":"NekIXrZ_94ewXKZO","title":"aEfOZqUeJYoYA1Pb","titleIcon":"dI7mAnMqBCcn2iQd","details":"dcNDCshBrLwH0X7C"};